import {useEffect, useState} from 'react';
import {API, getUserIdFromToken} from '@chekin/api';
import {useIVStore} from '@chekin/shared';
import {useSummary} from 'context/summary';
import {
  getIVIntentRemoteSession,
  setIVIntentRemoteSession,
} from 'hooks/iv/useIVRemoteSync';

type EnsureIVIntentArgs = {
  reservationId: string;
  isPropertyQRScanned: boolean;
};

export async function ensureIVIntent({
  reservationId,
  isPropertyQRScanned,
}: EnsureIVIntentArgs) {
  const existing = getIVIntentRemoteSession();
  if (existing) return existing;

  const intent = await API.identityVerification.createIvIntent({
    id: crypto?.randomUUID(),
    reservation_id: reservationId,
    user_id: getUserIdFromToken(),
    is_property_qr_scanned: isPropertyQRScanned,
  });
  setIVIntentRemoteSession(intent.id);

  return intent.id;
}

export function useIVIntent(enabled: boolean) {
  const {reservationId} = useSummary();
  const isPropertyQRScanned = useIVStore(state => state.isPropertyQRScanned);
  const [intentId, setIntentId] = useState(() => getIVIntentRemoteSession());

  useEffect(() => {
    if (!enabled || intentId) return;

    let cancelled = false;
    ensureIVIntent({reservationId, isPropertyQRScanned})
      .then(id => {
        if (!cancelled) setIntentId(id);
      })
      .catch(error => console.error(error));

    return () => {
      cancelled = true;
    };
  }, [enabled, intentId, reservationId, isPropertyQRScanned]);

  return intentId;
}
